import React from 'react';
import { Box } from '@mui/material';

// Theme colors
export const themeColors = {
  turqLight: '#CCF2F3', // Lighter turquoise for switches
  white: '#FFFFFF',
};

interface CustomSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({ checked, onChange, disabled }) => {
  return (
    <Box 
      data-testid="custom-switch-container"
      data-switch-state={checked ? 'enabled' : 'disabled'}
      sx={{ 
        position: 'relative',
        width: 51,
        height: 26,
        padding: 0,
        borderRadius: 13,
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: checked ? themeColors.turqLight : '#E0E0E0',
        transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: disabled ? 0.6 : 1
      }}
      onClick={disabled ? undefined : onChange}
    >
      <Box 
        data-testid="custom-switch-thumb"
        sx={{ 
          position: 'absolute',
          right: checked ? 3 : 'auto',
          left: checked ? 'auto' : 3,
          top: 3,
          width: 20,
          height: 20,
          backgroundColor: themeColors.white,
          borderRadius: '50%',
          transition: 'left 300ms cubic-bezier(0.4, 0, 0.2, 1), right 300ms cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
    </Box>
  );
};

export default CustomSwitch; 